import React from "react";
import { trackEvent } from "../../services/eventTracker";
import { EVENTS } from "../../constants/events";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../constants/clientRoutes";
import i18n from "../../i18n/config";
import { ACTION_DISPLAY_TYPES } from "../../constants/enums";

import Action from "../Common/Action";

const EnrollmentEntryModalBody = ({ setClose }: { setClose: () => void }) => {
  const history = useHistory();

  const handleStartEnrollmentClick = () => {
    trackEvent(EVENTS.ENROLLMENT.STARTED, {});
    history.push(ROUTES.ENROLLMENT.ENROLL);
  };

  return (
    <div className="v2 v3">
      <p className="abyss-blue font-size-xl mb-8 bold">{i18n.t("PAGES.LOGIN.ENROLLMENT_MODAL.HEADER")}</p>
      <p className="marengo-grey font-size-lg">{i18n.t("PAGES.LOGIN.ENROLLMENT_MODAL.LIST_HEADER")}</p>
      <ul className="mb-8 pl-8">
        <li className="mb-8 marengo-grey font-size-lg">{i18n.t("PAGES.LOGIN.ENROLLMENT_MODAL.LI_1")}</li>
        <li className="mb-8 marengo-grey font-size-lg">{i18n.t("PAGES.LOGIN.ENROLLMENT_MODAL.LI_2")}</li>
        <li className="mb-8 marengo-grey font-size-lg">{i18n.t("PAGES.LOGIN.ENROLLMENT_MODAL.LI_3")}</li>
        <li className="mb-8 marengo-grey font-size-lg">{i18n.t("PAGES.LOGIN.ENROLLMENT_MODAL.LI_4")}</li>
      </ul>

      <Action
        title={i18n.t("PAGES.LOGIN.ENROLLMENT_MODAL.ACTION_TEXT_1")}
        displayType={ACTION_DISPLAY_TYPES.TEXT}
        onClick={handleStartEnrollmentClick}
        className="mt-6 w-full"
        dataCy="enrollment-start-button"
      />

      <Action
        title={i18n.t("COMMON.GO_BACK")}
        displayType={ACTION_DISPLAY_TYPES.TEXT}
        onClick={setClose}
        className="mt-8 w-full"
      />
    </div>
  );
}

export default EnrollmentEntryModalBody;